// src/index.tsx

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import 'bootstrap/dist/css/bootstrap.min.css';


const msalInstance = new PublicClientApplication(msalConfig);

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);
